import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PermisoFormSections from "./PermisoFormSections.js";

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }


    setSelects(data) {
        this.setState({
            padre: data.padre_id,
        });
        
    }
    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.permisos.edit}
                postUrl={api.usuarios.permisos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Permiso ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Permiso"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setSelects(data)}>
                <div className="ui-form">
                    <PermisoFormSections padre={this.state.padre} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Permisos/Edit.js